import { SlideCarousel } from '@frontend/design-system';
import { chartColors, flexColumnStyle } from './constant';
import { PaymentsPieChart } from './pie-chart';
import { TotalInvoicesCount } from './total-invoices-count';
import { PaymentsChartData } from './types';

interface NarrowLayoutProps {
  chartDataList: PaymentsChartData;
  totalInvoices: number;
}

export const NarrowLayout = ({ chartDataList, totalInvoices }: NarrowLayoutProps) => {
  return (
    <SlideCarousel slides={['count', 'net']}>
      <SlideCarousel.Container>
        <SlideCarousel.Panel id='count'>
          <TotalInvoicesCount value={totalInvoices} />
        </SlideCarousel.Panel>
        <SlideCarousel.Panel id='net'>
          <div css={flexColumnStyle}>
            <PaymentsPieChart data={chartDataList.net} colors={chartColors} />
          </div>
        </SlideCarousel.Panel>
      </SlideCarousel.Container>
      <SlideCarousel.Navigation />
    </SlideCarousel>
  );
};
